function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n  #gradi{fill:url(#MyGradient)}\n");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "MyGradient",
  gradientTransform: "rotate(65)"
}, ">\n    ", /*#__PURE__*/React.createElement("stop", {
  offset: "50%",
  stopColor: "#107ff9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "95%",
  stopColor: "#2fb7ed"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "gradi"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M331.73,197.87H106.92V118.06a76.58,76.58,0,1,1,153.16,0v31.83h41.47V118.06a118.06,118.06,0,1,0-236.11,0v79.81H35.27A35.27,35.27,0,0,0,0,233.13V345c0,92.21,82.16,167,183.5,167S367,437.24,367,345V233.13A35.27,35.27,0,0,0,331.73,197.87ZM196.87,355.62l10.76,46H159.37l10.76-46a35.94,35.94,0,1,1,26.74,0Z"
})));

var SvgFeature03 = function SvgFeature03(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 367 512",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFeature03, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/feature03.1df15d90.svg";
export { ForwardRef as ReactComponent };